// extracted by mini-css-extract-plugin
module.exports = {"logoBigWrapper":"LogoWithVideo_logoBigWrapper__jrS7C","logoBig":"LogoWithVideo_logoBig__TcIOh","videoText":"LogoWithVideo_videoText__LF_ci"};